import propTypes from '../../node_modules/prop-types/index.js';
import { styled, useThemeProps } from '@mui/material';
import classnames from '../../node_modules/classnames/index.js';
import React from 'react';
import { DataListItemVerticalAlign } from './constants.js';
import { getCssPixelWidth } from '../../modules/styling/utils.js';
import DataListItemContent from './content/DataListItemContent.js';
import DataListItemFallback from './content/DataListItemFallback.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var componentRoot = createComponentSlot({
  name: "CinDataListItem",
  slot: "Root",
  skipForwardProps: ["width"]
});

var DataListItemBase = function DataListItemBase(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? null : _ref$fallback,
      className = _ref.className;
  // scenarios where the fallback will definitely not be shown
  // otherwise it may be required depending on whether children renders any DOM elements
  var fallbackNotRequired = fallback === null || typeof children === "number" || typeof children === "string" && children.trim() !== "";
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(componentRoot.className, className)
  }, /*#__PURE__*/React.createElement("dt", null, title), /*#__PURE__*/React.createElement("dd", null, fallbackNotRequired ? children : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DataListItemContent, null, children), /*#__PURE__*/React.createElement(DataListItemFallback, null, fallback))));
};

DataListItemBase.propTypes = {
  children: propTypes.node,
  width: propTypes.oneOfType([propTypes.number, propTypes.string]),
  title: propTypes.node.isRequired,
  fallback: propTypes.node,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any,
  color: propTypes.string,
  textAlign: propTypes.any,
  verticalAlign: propTypes.any
};
var DataListItemRoot = styled(DataListItemBase, componentRoot.styledOptions)(function (_ref2) {
  var _theme$palette;

  var theme = _ref2.theme,
      width = _ref2.width,
      color = _ref2.color,
      textAlign = _ref2.textAlign,
      _ref2$verticalAlign = _ref2.verticalAlign,
      verticalAlign = _ref2$verticalAlign === void 0 ? DataListItemVerticalAlign.Top : _ref2$verticalAlign;
  var colorValue = typeof color === "string" ? ((_theme$palette = theme.palette[color]) === null || _theme$palette === void 0 ? void 0 : _theme$palette.main) || color : color;
  return {
    width: getCssPixelWidth(width, "100%"),
    display: "inline-block",
    verticalAlign: verticalAlign,
    textAlign: textAlign,
    padding: theme.spacing(1),
    "> dt": {
      color: colorValue,
      fontWeight: "bold"
    },
    "> dd": {
      color: colorValue,
      marginLeft: 0
    }
  };
});
/**
 * A single item for a `dt` & `dd` element pair
 */

var DataListItem = function DataListItem(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(DataListItemRoot, rootProps);
};

var DataListItem$1 = DataListItem;

export { DataListItem$1 as default };
